import { Component } from '@angular/core';

@Component({
  selector: 'app-section-caixa-numeros',
  templateUrl: './section-caixa-numeros.component.html',
  styleUrls: ['./section-caixa-numeros.component.scss'],
})
export class SectionCaixaNumerosComponent {}
